import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCounter, useEvent, useThrottle } from 'react-use';

import { achievementsActions } from 'app-components/flux/achievements';

const AchievementsNotifier = () => {
  const dispatch = useDispatch();
  const [clicks, { inc }] = useCounter(0);
  const onClick = useCallback(() => inc(), [inc]);
  useEvent('click', onClick, window);
  const clicksThrottled = useThrottle(clicks, 1000 * 60 * 60 * 24); // once per 24 hours
  useEffect(() => {
    dispatch(achievementsActions.sendAchievementsEvent({ source: 'UAA', eventType: 'LOGIN' }));
  }, [clicksThrottled, dispatch]);
  return null;
};

export default AchievementsNotifier;
